export default __webpack_public_path__ + "static/media/fsiRealCase1-mobile-sc.fe3ffb8d.jpg";